import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { FolderOpen } from 'lucide-react';
import ActionLinkButton from '@/shared/components/ui/ActionLinkButton';
import SidebarWrapper from '@/shared/components/SidebarWrapper';
import Header from './Header';
import PageList from './PageList';
import PageListHeader from './PageListHeader';
import SidebarFooter from './SidebarFooter';
import SearchButton from '../Search';
import { usePageSelection } from '@/features/pages/hooks/usePageSelection';

const Sidebar = () => {
  const navigate = useNavigate();

  const { setCurrentPageId } = usePageSelection();

  const goToCollections = useCallback(async () => {
    await setCurrentPageId(null);
    navigate(`/collections`);
  }, [navigate, setCurrentPageId]);

  return (
    <SidebarWrapper>
      <Header />
      <div className="pl-2 pr-2">
        <SearchButton />
        <ActionLinkButton Icon={FolderOpen} title={'Collections'} onClick={goToCollections} />
      </div>
      <div className="flex-grow pl-1">
        <PageListHeader />
        <PageList />
      </div>
      <SidebarFooter />
    </SidebarWrapper>
  );
};

export default Sidebar;
